<!-- test-score-popup.component.html -->
<div class="d-flex justify-content-between align-items-center">
    <p class="fw-bold fs-3 ms-4 mt-2">{{ testType.toUpperCase() }} Score</p>
    <i (click)="closeModal()" class="bi bi-x fs-2 cursor-pointer"></i>
</div>

<div class="container p-3 mb-1">
    <aerp-base-schema-form 
        *ngIf="model" 
        [model]="model" 
        [layout]="layout"
        [dataProcessor]="dataProcessor.bind(this)" 
        [dataModel]="dataModel"
        (onSubmit)="onSubmit($event)">
    </aerp-base-schema-form>
</div>

